import * as React from 'react';
import { useTheme, Box, IconButton, Paper, Typography } from '@mui/material';
import { Save as SaveIcon, Delete as DeleteIcon, PlayCircle as PlayCircleIcon, } from '@mui/icons-material';
import { useAmaWorkflowContext } from '../../../../context/ama-workflow-provider';
import { SnapshotStatus } from '../../../../data/enums';
import { StyledSectionHeader } from '../../../../themes/styled-components';

interface ISnapshotsActionsCard {
  snapshot: ISnapshot;
  setIsDownloading: React.Dispatch<React.SetStateAction<boolean>>;
  setSnapshotForDelete: React.Dispatch<React.SetStateAction<ISnapshot | null>>;
}

export default function SnapshotsActionsCard (props: ISnapshotsActionsCard) {

  const theme = useTheme();
  const { clients, runSnapshotSilverJob, saveSnapshotToCensus } = useAmaWorkflowContext();    
  
  const snapshotClient = (clients === null) ? null : clients.find(client => client.ClientId === props.snapshot.ClientId);
  const isCaptureCensusDisabled = (snapshotClient === null) ? true : !snapshotClient?.IsCensusHistoricAvailable;

  const handleDeleteButtonClick = () => {
    props.setSnapshotForDelete({ 
      ClientId: props.snapshot.ClientId, 
      SnapshotDate: props.snapshot.SnapshotDate, 
      Status: '', 
      IsCollectionComplete: false, 
      Jobs: []});
  };

  const handleSnapshotRerunClick = () => {
    runSnapshotSilverJob(props.snapshot.ClientId, props.snapshot.SnapshotDate);
  };

  const handleSaveToCensusClick = () => {
    saveSnapshotToCensus(props.snapshot.ClientId, props.snapshot.SnapshotDate);
  };

  const buttonStyle = {
    backgroundColor: 'white', 
    color: theme.palette.grey[500],
    borderColor: theme.palette.grey[400],    
    '&:hover': { 
      color: theme.palette.grey[500],
      backgroundColor: theme.palette.grey[100],
      borderColor: theme.palette.grey[400],   
    }, 
  };

  const getRunSilverButtonLabel = (snapshot: ISnapshot) => {
    if (snapshot.Status === SnapshotStatus.SilverTransformed || snapshot.Status === SnapshotStatus.GoldTransformed) return 'Rerun Glue Job';
    return 'Run Glue Job';
  };

  return (
    <Box sx={{ height: '100%' }}>
      <Paper sx={{ height: '100%', p: 2}}>
        <StyledSectionHeader>Actions</StyledSectionHeader>
        <Box display="flex" flexDirection="column" gap={2}>
          <Box display="flex" flexDirection="row" alignItems="center">
            <IconButton 
              aria-label="Delete Snapshot" 
              sx={buttonStyle}
              onClick={handleDeleteButtonClick}>
              <DeleteIcon />
            </IconButton>
            <Typography sx={{ fontSize: '0.7rem', color: theme.palette.text.secondary}}>
              Delete Snapshot
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row" alignItems="center">
            <IconButton 
              aria-label="Run Silver Job" 
              sx={buttonStyle}
              onClick={handleSnapshotRerunClick}>
              <PlayCircleIcon />
            </IconButton>
            <Typography sx={{ fontSize: '0.7rem', color: theme.palette.text.secondary}}>
              {getRunSilverButtonLabel(props.snapshot)}
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row" alignItems="center">
            <IconButton 
              aria-label="Save to Census" 
              sx={buttonStyle}
              disabled={isCaptureCensusDisabled}
              onClick={handleSaveToCensusClick}>
              <SaveIcon />
            </IconButton>
            <Typography sx={{ fontSize: '0.7rem', color: theme.palette.text.secondary}}>
              Save to Census
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}